import { request } from '@/utils/request'
import qs from 'qs'

/**
 * @description 获取商品列表
 */
export function getGoodsList(params: any) {
  return request({
    url: '/zhongcaijie/h5/goods/getH5ZcjGoodsListByCondition',
    method: 'get',
    params,
  })
}
/**
 * @description 获取历史商品列表
 */
export function getH5ZcjGoodsListUserVisit(params: any) {
  return request({
    url: '/zhongcaijie/h5/goods/getH5ZcjGoodsListUserVisit',
    method: 'get',
    params,
  })
}

/**
 * @description 获取商品商品详情
 */
export function getGoodsDetail(params: any) {
  return request({
    url: '/zhongcaijie/h5/goods/getGoodsInfo',
    method: 'get',
    params,
  })
}

/**
 * @description 获取推荐类型，用户获取推荐商品
 */
export function getGoodsRecommendType() {
  return request({
    url: '/zhongcaijie/h5/goods/getRecommendCondition',
    method: 'get',
  })
}

/**
 * @description 获取拥有商品的城市
 */
export function getHadGoodsCity() {
  return request({
    url: '/zhongcaijie/h5/goods/getHadGoodsCity',
    method: 'get',
  })
}

/**
 * @description 获取商品热搜词
 */
export function getGoodsHotSearchWord() {
  return request({
    url: '/zhongcaijie/h5/goods/search/getGoodsHotSearchWord',
    method: 'get',
  })
}

/**
 * @description 获取商品类型
 */
export function getGoodsType(params: { showLevel: number }) {
  return request({
    url: '/zhongcaijie/h5/goods/showGoodsType',
    method: 'get',
    params,
  })
}

/**
 * @description 商品分类==查询商品类型的下一级类型
 */
export function getGoodsTypeByParentId(params: { parentId: number }) {
  return request({
    url: '/zhongcaijie/h5/goods/showGoodsTypeByParentId',
    method: 'get',
    params,
  })
}

/**
 * @description 获取精品分类/推荐分类
 */
export function getGoodsTypeBoutique(params: any) {
  return request({
    url: '/zhongcaijie/h5/goodstype/boutique/getGoodsTypeBoutique',
    method: 'get',
    params,
  })
}

/**
 * @description 获取积分商品一级类型
 */
export function getIntegralFirstGoodsType(params: any) {
  return request({
    url: '/zhongcaijie/h5/integralGoodsType/getIntegralGoodsTypeOneList',
    method: 'get',
    params,
  })
}

/**
 * @description 获取积分商品二级类型
 */
export function getIntegralGoodsTypeTwoList(id: number) {
  return request({
    url: '/zhongcaijie/h5/integralGoodsType/getIntegralGoodsTypeTwoList',
    method: 'get',
    params: { id },
  })
}

/**
 * @description 查询积分商品信息
 */
export function getH5IntegralGoodsList(params: any) {
  return request({
    url: '/zhongcaijie/h5/integralGoods/getH5IntegralGoodsList',
    method: 'get',
    params,
  })
}

/**
 * @description 查询积分商品详情信息
 */
export function getIntegralGoods(id: number) {
  return request({
    url: '/zhongcaijie/h5/integralGoods/getIntegralGoods',
    method: 'get',
    params: { id },
  })
}

/**
 * @description 查询积分商品订单信息
 */
export function getH5IntegralGoodsOrderList(params: any) {
  return request({
    url: '/zhongcaijie/h5/integralGoodsOrder/getH5IntegralGoodsOrderList',
    method: 'get',
    params,
  })
}

/**
 * @description 用户积分记录
 */
export function getUserIntegralLogList(params: any) {
  return request({
    url: '/zhongcaijie/h5/integralGoodsOrder/getUserIntegralLogList',
    method: 'get',
    params,
  })
}

/**
 * @description 用户收货地址
 */
export function getUserAddress() {
  return request({
    url: '/zhongcaijie/h5/userAddress/getUserAddress',
    method: 'get',
  })
}

/**
 * @description 添加/编辑用户收货地址
 */
export function addOrUpdateUserAddress(data: any) {
  return request({
    url: '/zhongcaijie/h5/userAddress/editUserAddress',
    method: 'post',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: qs.stringify(data),
  })
}

/**
 * @description 创建积分订单
 */
export function addIntegralGoodsOrder(data: any) {
  return request({
    url: '/zhongcaijie/h5/integralGoodsOrder/addIntegralGoodsOrder',
    method: 'post',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: qs.stringify(data),
  })
}

/**
 * @description 删除用户收货地址
 */
export function deleteUserAddress(data: any) {
  return request({
    url: '/zhongcaijie/h5/userAddress/deleteUserAddress',
    method: 'post',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: qs.stringify(data),
  })
}

/**
 * @description 积分抽奖配置详情
 */
export function getH5IntegralLotterySettings() {
  return request({
    url: '/zhongcaijie/h5/integralGoodsOrder/getH5IntegralLotterySettings',
    method: 'get',
  })
}

/**
 * @description 积分抽奖
 */
export function integralLuckDraw() {
  return request({
    url: '/zhongcaijie/h5/integralGoodsOrder/IntegralLuckDraw',
    method: 'post',
  })
}

/**
 * @description 积分抽奖记录
 */
export function getIntegralWinningRecordList(params: any) {
  return request({
    url: '/zhongcaijie/h5/integralGoodsOrder/getIntegralWinningRecordList',
    method: 'get',
    params,
  })
}

/**
 * @description 签到
 */
export function addUserSign(params: any) {
  return request({
    url: '/zhongcaijie/h5/userSign/addUserSign',
    method: 'post',
    params,
  })
}

/**
 * @description 用户签到信息
 */
export function getUserSignList() {
  return request({
    url: '/zhongcaijie/h5/userSign/getUserSignList',
    method: 'get',
  })
}

/**
 * @description 用户任务信息
 */
export function getUserIntegralTask() {
  return request({
    url: '/zhongcaijie/h5/userSign/getUserIntegralTask',
    method: 'get',
  })
}

/**
 * @description 获取专属服务
 */
export function obtainingExclusiveServices(params: any) {
  return request({
    url: '/zhongcaijie/h5/chat/obtainingExclusiveServices',
    method: 'get',
    params,
  })
}
